module.exports = __webpack_public_path__ + "static/img/Baccarat-sp.d907544.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sp/Baccarat-sp.png
// module id = HUP0
// module chunks = 1